<!-- Groups centrale Modal         size="xl" -->
<template>
    <b-modal
      :visible="visible" 
      @hidden="hide" 
      @change="change"
      @show="tableGroups"
      scrollable
      fullscreen
      ref="modal"
      id="modal-groups-cu"
      :title="getTitle"
      @ok="handleRemove"
    >
      
      <!-- <template #modal-footer="{ save }">
        <b-button >CHIUDI</b-button>
        <b-button v-if="modified" variant="primary" @click="salvaModifiche()">{{$t('groups_cu_modal.save')}}</b-button>
      </template> -->
        <b-row>
          <b-col cols="2" class="text-center">
          </b-col> 
          <b-col cols="10" class="text-center">
           <h6 class="mt-3">{{$t('lamp_details_modal.groups')}}
           <span :content="$t('groups_cu_modal.info')" v-tippy="{ placement : 'top',  arrow: true }"> <i class="fa fa-info-circle" style="color:#0090CD"></i></span>    
          </h6>  
          </b-col>  
          <!---- TABLE GROUP CENT -->    
          <!--<v-client-table v-if="tableData.length>=0" :columns="columns" :data="tableData" :options="options" :theme="theme" id="dataTable" ref="table" class="borderless text-primary widget-table">                 
          <template v-for="(group, index) in this.maxGroups" :slot="group" slot-scope="props">
            <span :key="index">
              <i :id="'i-'+props.row.id+'-'+group" class="fa fa-circle" v-bind:class="[dotClassGroup(group,props.row.groups)]" @click="toggle(group,props)" /> 
            </span>
          </template>
          </v-client-table>-->
          <table v-if="tableData.length>0" id="groupTable" ref="table" class="table table-striped">
            <thead>
              <tr>
                <th>Serial Number</th>
                <th>{{$t('cards.description')}}</th>
                <th>1</th>
                <th>2</th>
                <th>3</th>
                <th>4</th>
                <th>5</th>
                <th>6</th>
                <th>7</th>
                <th>8</th>
                <th>9</th>
                <th>10</th>
                <th>11</th>
                <th>12</th>
                <th>13</th>
                <th>14</th>
                <th>15</th>
                <th>16</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(lamp,index) in this.tableData">
                <td>{{lamp.id}}</td>
                <td>--</td>
                <td v-for="(group,gindex) in maxGroups" :key="gindex">
                  <i :id="'i-'+lamp.id+'-'+group" class="fa fa-circle" v-bind:class="[dotClassGroup(group,lamp.groups)]" @click="toggle2(group,lamp)" />
                </td>
              </tr>
            </tbody>
          </table>

        </b-row>
    </b-modal>
</template>

<script>
import Vue from 'vue'
import { mapState } from "vuex";
import {ClientTable, Event} from 'vue-tables-2'
Vue.use(ClientTable)

export default {
  name: "GroupsCentralUnit",
  model: {
    prop: "visible",
    event: "change"
  },
  props: {
    cu: {
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    },
    readonlyMode: {
      type: Boolean,
      default: undefined 
    },
  },
  data() {
    return {
      columns: ['id','desc','1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16'],
      tableData: [],
      maxGroups:16,
      modified: false,
      theme: 'bootstrap4',
      template: 'default',  
      options: {
                  perPage: 10, 
                  perPageValues: [10,20,32,50,128],
                  texts:{
                        limit: this.$t("report_table.record_per_page"),
                        count:'{count} report'
                  },
                  pagination: { dropdown:false, chunk:5, show: true },
                  stickyHeader: true,
                  rowClassCallback: this.centRowClass,
                  filterByColumn: false,
                  uniqueKey: 'timestamp' ,
                  columnsClasses: {'desc':'descColumnClass', 'image':'imgColumnClass', 'check':'chkColumnClass','dettaglio':'dettColumnClass'},
                  headings: {
                        id:'Serial number',
                        desc: this.$t('cards.description'),
                        1:'1',
                        2:'2',
                        3:'3',
                        4:'4',
                        5:'5',
                        6:'6',
                        7:'7',
                        8:'8',
                        9:'9',
                        10:'10',
                        11:'11',
                        12:'12',
                        13:'13',
                        14:'14',
                        15:'15',
                        16:'16'                    
                    }
                },
      cuSerial: "",
      cuType: "",
      cuDesc:"",
      footer_hide: false,
      plantUnits: this.$store.state.plantUnits,
      timerTimeout: 5,


    };
  },
  computed: { 
    getTitle(){
      return this.$t("groups_cu_modal.title",{cent:this.cuType + ' - ' + this.cuSerial})
    },
    cuLampsDetails() {
      const plant = this.$store.state.currentPlant;
            if (plant == null)  {
                this.tableData = [];
                return null;
            }
            if (plant.id != this.plantId) return null;
            return plant;
        },
    isReadOnly() {
      return this.readonlyMode !== undefined;
    }
  },
  methods: {  
    hide() {
      this.$emit("hide");
    },
    change(visible) {
      this.$emit("change", visible);
    },
    tableGroups() {
      console.log("Current page:", this.$router.currentRoute);
      this.modified = false;
      if(this.$router.currentRoute.name=="Illuminazione")
        this.tableData=this.cu.lamps_illum;
      else
        this.tableData=this.cu.lamps;
      this.cuType=this.cu.cu_type;
      this.cuSerial=this.cu.cu_id;
      console.log("Table groups",this.tableData);
    },
    dotClassGroup(group, groups) {
    if (groups.indexOf(group) != -1)
      return "dot-connected"
    else
      return "dot-disconnected"
    },
    toggle(group, props) {
      var row = props.row;
      console.log("toggle " + group,props);
      let idx = row.groups.indexOf(group)
      if (idx >= 0) {
        console.log("rimosso da gruppo");
        row.groups.splice(idx,1);
      } else {
        row.groups.push(group);
        console.log("inserito nel gruppo");
      }
      this.modified = true;
      row.modifiedGroup = true;
      this.$forceUpdate();
    },
    toggle2(group, lamp) {
      if(!this.isReadOnly){
        console.log("toggle " + group,lamp);
        let idx = lamp.groups.indexOf(group)
        if (idx >= 0) {
          console.log("rimosso da gruppo");
          lamp.groups.splice(idx,1);
        } else {
          lamp.groups.push(group);
          console.log("inserito nel gruppo");
        }
        this.modified = true;
        lamp.modifiedGroup = true;
        this.$forceUpdate();
      }
    },
    salvaModifiche() {
      console.log("tableData",this.tableData);
      this.$store.dispatch('setMultiGroup', {cu: this.cu, data: this.tableData});

      // Hide the modal manually
      this.$nextTick(() => {
        this.$refs.modal.hide();
      });
    },
    handleRemove(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
     }
  }
};
</script>

<style lang="scss">
  #td_empty{ width: 5%; text-align: left;} 
  #td_id{ width: 20%; text-align: left;} 
  #td_stato{ width: 10%; text-align: center;} 
  #td_desc { width: 20%;  text-align: left;} 
  #td_prod { width: 30%; text-align: left;} 
  #td_err { width: 15%; text-align: right;}

  #div_timestamp{ width: 100%; text-align: left;} 
  #div_cent{ width: 100%; text-align: left;} 
  #div_test { width: 100%; text-align: left;} 
  #div_stato { width: 100%; text-align: center;} 
  #div_download { width: 100%; text-align: right;} 

  .dot-connected {
        color: yellowgreen
    }

  .dot-disconnected {
      color: #bbb
  }

  #dataTable {
    width: 95%;
    margin: 0 auto;
    outline: none;

    td {
        outline: none !important;
    }

    th {
        outline: none !important;
    }
    
    

    .check-ok {
        color: yellowgreen
    }

    .check-err {
        color: red
    }
    
    .check-not-config {
        color: orange
    }

    .cent-error {
       color:red;
       visibility:none;
    }

   .cent-warning {
       color:orange;
       visibility:none;
    }

    .cent-no-error {
       visibility:hidden;
    }

    .VuePagination {
      text-align: center;
      justify-content: center;
    }

    .vue-title {
      text-align: center ;
      margin-bottom: 10px;
    }

    .VueTables__table {
      border-collapse: collapse;
    }

    .VueTables__search-field {
      visibility:hidden;
      display: none;
    }

    .VueTables__search-field input {
      margin-left: 0.25rem;
    }

    .VueTables__limit-field {
      display: flex;
    }

    .VueTables__limit-field select {
      margin-left: 0.25rem !important;
    }

    tr.VueTables__row {
        background-color: #fff !important;
        border-top: 1px solid #c8ced3;
        font-size: 13px;
        color: black;
    }

    .VueTables__table th {
      
    font-size: 13px;
    font-weight: 400;
    color: black;
    }

    .VueTables__table td {
        vertical-align: middle;
        
    }

    .VueTables__child-row-toggler {
      width: 16px;
      height: 16px;
      line-height: 16px;
      display: block;
      margin: auto;
      text-align: center;
      border: solid 0px;
    }

    .VueTables__child-row:hover {
        background-color: #fff;
    }

    .VueTables__child-row thead tr {
        background-color: #fff;
    }

    .VueTables__child-row tbody tr {
        background-color: #fff !important;
        border-bottom: 1px solid #ddd;
    }

    .VueTables__child-row thead tr:hover {
        background-color: #fff;
    }

    .VueTables__child-row-toggler--closed::before {
       content: "\f067";  // simbolo + di fontawesome
       font-family: FontAwesome;
       color:lightseagreen;
    }

    .VueTables__child-row-toggler--open::before {
       content: "\f068";  // simbolo - di fontawesome
       font-family: FontAwesome;
       color:lightseagreen;
    }

    .VueTables__table .sp_cent_cod {
        margin-left: 20px;
    }

  }
   
   .text-widget {
        font-family: 'Roboto Condensed', sans-serif;
        font-size: 15px;
    }

    .card-header {
        background-color: #ffffff;  
    }

    #groupTable {
      width: 100%;
      margin-left:1em;
      position: relative;
      border-collapse: collapse;
    }

    #groupTable th {
      background-color: #fafafa;
      position: sticky;
      -webkit-position: sticky;
      top: -17px;
      margin-top: 0px;
      border-bottom: 2px solid #999;
    }

</style>